module.exports = __webpack_public_path__ + "img/360-note.53dd0061.svg";